import styled from "@emotion/styled";

const FaqContainer = styled.section`
    display: flex;
    flex-direction: column;
`

export default FaqContainer